import { BaseDTO } from './basedto';
import { ProposalEffectivity } from './proposaleffectivity';
import { ProposalPackageLevel } from './proposalpackagelevel';
import { PackageType } from './packagetype';
import { ProposalSourceType } from './proposalsourcetype';
import { RejectionReason } from './rejection-reason';
import { ProposalReasonTestDoc } from './proposalreasontestdoc';

export class PackageInfo extends BaseDTO {
    GroupId: number;
    PackageTypeId: number;
    PackageTypeDescription: string;
    TransportModeId: number;
    UOMSystemId: number;
    TransportModeDescription: string;
    SourceTypes: ProposalSourceType[];
    SourceTypeIds: number[];
    SourceTypeId: number;
    RejectionComment: string;
    NonSubTestDocReason: string;
    TestDocComment: string;
    Comment: string; // proposal level comment
    ProposalEffectivity: ProposalEffectivity;
    ProposalReasonTestDoc: ProposalReasonTestDoc;
    WorkflowStatusId: number | null;
    IsFitForAirShipment: boolean;
    IsStackable: boolean;
    NonStackabilityReason: string;
    NoOfStackableUnitsForShipping: number;
    NoOfStackableUnitsForWarehousing: number;
    IsRotatable: boolean;
    RotationComment: string;
    IsPhysicalInspectionPass: boolean;
    IsServiceOptimized: boolean;
    IsTeslaCreated: boolean;
    Note: string;
    RejectionReason: RejectionReason[];
    ProposalPackageLevels: ProposalPackageLevel[] = [];
    IsForTesla: boolean = false;
    IsConditionalApproval: boolean;
    IsResubmittedAfterConditionalApproval: boolean;
    ConditionalApprovalMessage: string;
    constructor() {
        super();
        this.ProposalEffectivity = new ProposalEffectivity();
        this.ProposalReasonTestDoc = new ProposalReasonTestDoc();
        this.SourceTypes = [];
        this.SourceTypeIds = [];
    }
}
